import ctx from "../../plugins/axios";

/**
 * Send a reminder email for a specialty list at its current status.
 * Reuses the existing /specialty_list/clone endpoint (repurposed).
 *
 * @param {Object} params - { uuid: string, current_status: string }
 * @returns {Promise<*>}
 */
const sendReminder = async (params) => {
  return await ctx.post("/specialty_list/clone", params);
};

export default sendReminder;
